import styled from 'styled-components';

export const Wrapper = styled.div`
  flex: 1;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  gap: 10px;
`;

export const Box = styled.div`
  width: 300px;
  height: 300px;
  border-radius: 20px;
  line-height: 300px;
  text-align: center;
  font-size: 40px;

  &.triangle {
    clip-path: polygon(50% 0%, 0% 100%, 100% 100%);
  }

  &.circle {
    border-radius: 50%;
  }
`;
